import { Call, ConversationMessage } from '../types';

// Generate some initial call history
export const dummyCalls: Call[] = [
  {
    id: '1',
    patientId: '1',
    patientName: 'Maria Elena Rodriguez',
    startTime: new Date(Date.now() - 3600000), // 1 hour ago
    endTime: new Date(Date.now() - 3300000), // 55 minutes ago
    duration: 300, // 5 minutes
    status: 'ended',
    type: 'inbound',
    purpose: 'appointment',
    urgencyLevel: 'medium',
    messages: [
      {
        id: '1',
        speaker: 'ai',
        content: '¡Hola! Gracias por llamar a Estrabillo Dental Group. Soy Eev, su asistente de IA. ¿Cómo puedo ayudarle hoy?',
        timestamp: new Date(Date.now() - 3600000),
        language: 'es'
      },
      {
        id: '2',
        speaker: 'patient',
        content: 'Hola, tengo un dolor de muelas muy fuerte. Es insoportable.',
        timestamp: new Date(Date.now() - 3580000),
        language: 'es'
      },
      {
        id: '3',
        speaker: 'ai',
        content: 'Entiendo que tiene un dolor muy fuerte. En una escala del 1 al 10, ¿cómo calificaría su dolor?',
        timestamp: new Date(Date.now() - 3560000),
        intent: 'emergency_assessment',
        confidence: 0.95,
        language: 'es'
      },
      {
        id: '4',
        speaker: 'patient',
        content: 'Es un 9 de 10. No puedo dormir y tengo diabetes, ¿eso afecta el tratamiento?',
        timestamp: new Date(Date.now() - 3540000),
        language: 'es'
      },
      {
        id: '5',
        speaker: 'ai',
        content: 'Sí, veo en su historial que tiene diabetes tipo 2. Esto es importante para el tratamiento. Voy a programarle una cita de emergencia inmediatamente.',
        timestamp: new Date(Date.now() - 3520000),
        intent: 'emergency_appointment',
        confidence: 0.98,
        language: 'es'
      }
    ],
    summary: 'Emergency dental pain with diabetes considerations - appointment scheduled',
    aiSummary: 'Patient Maria Rodriguez called with severe tooth pain (9/10). Has diabetes type 2 which affects treatment planning. Emergency appointment scheduled. Key findings: severe pain, diabetes complications, requires specialized care protocols.'
  },
  {
    id: '2',
    patientId: '2',
    patientName: 'James Patterson',
    startTime: new Date(Date.now() - 7200000), // 2 hours ago
    endTime: new Date(Date.now() - 6900000),
    duration: 360, // 6 minutes
    status: 'ended',
    type: 'inbound',
    purpose: 'inquiry',
    urgencyLevel: 'medium',
    messages: [
      {
        id: '4',
        speaker: 'ai',
        content: 'Hello! Thank you for calling Estrabillo Dental Group. This is Eev, your AI assistant. How can I help you today?',
        timestamp: new Date(Date.now() - 7200000),
        language: 'en'
      },
      {
        id: '5',
        speaker: 'patient',
        content: 'Hi, I got your reminder call. Actually, I wanted to ask about my night guard.',
        timestamp: new Date(Date.now() - 7180000),
        language: 'en'
      },
      {
        id: '6',
        speaker: 'ai',
        content: 'Of course! I see you have a history of teeth grinding. How is your current night guard working for you?',
        timestamp: new Date(Date.now() - 7160000),
        intent: 'equipment_inquiry',
        confidence: 0.88,
        language: 'en'
      },
      {
        id: '7',
        speaker: 'patient',
        content: 'It\'s been uncomfortable lately and I think it might be cracked. Should I still wear it?',
        timestamp: new Date(Date.now() - 7140000),
        language: 'en'
      },
      {
        id: '8',
        speaker: 'ai',
        content: 'A cracked night guard can actually cause more harm than good. Please stop using it immediately. I\'ll schedule you for an evaluation and fitting for a new one.',
        timestamp: new Date(Date.now() - 7120000),
        intent: 'equipment_replacement',
        confidence: 0.92,
        language: 'en'
      }
    ],
    summary: 'Night guard replacement needed - evaluation scheduled',
    aiSummary: 'Patient James Patterson called about damaged night guard causing discomfort. History of bruxism noted. Scheduled evaluation and replacement. Key findings: cracked night guard, continued grinding, needs new appliance.'
  },
  {
    id: '3',
    patientId: '3',
    patientName: 'Dr. Ashley Chen',
    startTime: new Date(Date.now() - 10800000), // 3 hours ago
    endTime: new Date(Date.now() - 10200000),
    duration: 420, // 7 minutes
    status: 'ended',
    type: 'inbound',
    purpose: 'consultation',
    urgencyLevel: 'medium',
    messages: [
      {
        id: '6',
        speaker: 'ai',
        content: 'Hello! Thank you for calling Estrabillo Dental Group. This is Eev, your AI assistant. How can I help you today?',
        timestamp: new Date(Date.now() - 10800000),
        language: 'en'
      },
      {
        id: '7',
        speaker: 'patient',
        content: 'Hello, this is Dr. Chen. I need to discuss my upcoming root canal procedure.',
        timestamp: new Date(Date.now() - 10780000),
        language: 'en'
      },
      {
        id: '8',
        speaker: 'ai',
        content: 'Hello Dr. Chen! I see you have a root canal scheduled for January 20th. As a healthcare professional, I\'m sure you have specific questions. How can I help?',
        timestamp: new Date(Date.now() - 10760000),
        intent: 'professional_consultation',
        confidence: 0.90,
        language: 'en'
      },
      {
        id: '9',
        speaker: 'patient',
        content: 'I have a latex allergy. I want to ensure all materials used will be latex-free.',
        timestamp: new Date(Date.now() - 10740000),
        language: 'en'
      },
      {
        id: '10',
        speaker: 'ai',
        content: 'Absolutely, I see your latex allergy clearly noted in your file. I\'ve already flagged your appointment for latex-free protocols. All gloves, dam materials, and equipment will be latex-free.',
        timestamp: new Date(Date.now() - 10720000),
        intent: 'allergy_accommodation',
        confidence: 0.97,
        language: 'en'
      }
    ],
    summary: 'Professional consultation - latex-free protocols confirmed for root canal',
    aiSummary: 'Dr. Ashley Chen (healthcare professional) called regarding upcoming root canal procedure. Has latex allergy - all protocols confirmed latex-free. Key findings: latex allergy accommodation, professional patient requiring detailed information.'
  }
];